export default __webpack_public_path__ + "static/logo-white-small-7ac0b9dd044d96ad0446f7c735eabfb1.png";